<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      <span *ngIf="label">
        {{ label }}
      </span>
      <span *ngIf="!label">
        {{ 'USER_SELECT.USER' | translate }}
      </span>
    </span>

    <span *ngIf="parentFormGroup.get(passFormControlName).value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-select
    [items]="data | async"
    [multiple]="true"
    bindLabel="names"
    [formControlName]="passFormControlName"
    appendTo="body"
    [typeahead]="input$"
    (change)="onChange($event)"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="user-select-option-wrapper">
        <div class="user-name">{{ item.names }}</div>
        <div class="user-email" *ngIf="item.fake_email">
          {{ item.fake_email }}
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'USER_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
</div>
